export default __webpack_public_path__ + "static/media/sensotrend_go_to_kanta.cf35bcb5.png";